import React from "react";
import PropTypes from "prop-types";

import Dropdown from "../Dropdown";
import TitledContainer, { StaticText } from "../TitledContainer";

export default class TitledDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isEdit) {
      this.setState({ isOpen: false });
    }
  }

  handleEdit() {
    this.setState({ isOpen: true });
    if (this.props.onEdit) this.props.onEdit();
  }

  handleSelect(item) {
    this.setState({ isOpen: false });
    this.props.onSelect(item);
  }

  render() {
    const {
      component,
      emptyText,
      inputComponentProps,
      inputValueExtractor,
      isEdit,
      isRequired,
      isSorted,
      isUnselectable,
      placeholder,
      selectedValue,
      title,
      unitSize,
      valueExtractor,
      values,
    } = this.props;

    const extractor = inputValueExtractor || valueExtractor;
    const value = selectedValue ? extractor(selectedValue) : emptyText;

    return (
      <TitledContainer
        isEdit={isEdit}
        isEmpty={!selectedValue}
        onEdit={this.handleEdit}
        title={title}
        isEditable
      >
        {isEdit ? (
          <Dropdown
            component={component}
            inputComponentProps={{
              isRequired,
              size: unitSize,
              ...inputComponentProps,
            }}
            inputValueExtractor={extractor}
            isOpen={this.state.isOpen}
            isUnselectable={isUnselectable}
            onChange={this.handleSelect}
            placeholder={placeholder}
            selectedValues={selectedValue ? [selectedValue] : []}
            valueExtractor={component ? valueExtractor : (v) => ({ label: valueExtractor(v) })}
            values={isSorted ? [...values].sort() : values}
          />
        ) : (
          <StaticText isGray={!selectedValue && !!emptyText} text={value} />
        )}
      </TitledContainer>
    );
  }
}

const dropdownTypes = [PropTypes.node, PropTypes.object, PropTypes.string];

TitledDropdown.propTypes = {
  component: PropTypes.func,
  inputComponentProps: PropTypes.object, // eslint-disable-line
  title: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.oneOfType(dropdownTypes)).isRequired,
  emptyText: PropTypes.string,
  selectedValue: PropTypes.oneOfType(dropdownTypes),
  unitSize: PropTypes.number,
  isEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  isUnselectable: PropTypes.bool,
  onEdit: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  isSorted: PropTypes.bool,
  valueExtractor: PropTypes.func,
  inputValueExtractor: PropTypes.func,
};

TitledDropdown.defaultProps = {
  inputComponentProps: {},
  valueExtractor: (v) => v,
};
